export enum EcheckPortalTypes {
    Account = 'Account',
    Enrollment = 'Enrollment',
    CustomerCare = 'CustomerCare',
    Shop = 'Shop'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/echeck-portal-types.enum.ts